module.exports = __webpack_public_path__ + "img/26.b05c51de.jpg";